import { getUserDisplayName, type User } from "../../hooks/useUser";
import { useClientTranslations } from "../../lib/i18n/client";
import { ProgressCircle } from "../home/ProgressCircle";
import styles from "./PersonalizedGreeting.module.css";

function getTimeOfDayGreetingKey(): string {
	const hour = new Date().getHours();
	if (hour < 12) return "greeting.goodMorning";
	if (hour < 18) return "greeting.goodAfternoon";
	return "greeting.goodEvening";
}

interface PersonalizedGreetingProps {
	user: User;
	showProgressCircle?: boolean;
	taskCount?: number;
	completed?: boolean;
}

export function PersonalizedGreeting({
	user,
	showProgressCircle = false,
	taskCount = 3,
	completed = false,
}: PersonalizedGreetingProps) {
	const { t } = useClientTranslations("common");

	const userName = getUserDisplayName(user);

	if (showProgressCircle) {
		return (
			<div className={styles.containerWithProgress}>
				<ProgressCircle percentage={completed ? 100 : 33} />
				<div className={styles.textBlock}>
					<h1 className={styles.titleStart}>
						{completed
							? t("home.completedTitle", { name: userName })
							: `${t(getTimeOfDayGreetingKey())}, ${userName}`}
					</h1>
					<p className={styles.subtitle}>
						{completed
							? t("home.completedSubtitle")
							: t("home.taskSubtitle", { count: taskCount })}
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className={styles.container}>
			<h1 className={styles.title}>
				{t(getTimeOfDayGreetingKey())}, {userName}
			</h1>
		</div>
	);
}
